import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    newAddress:null,
    newLocation:null
  },
  mutations: {
    setNewAddress(state,newAddress){
      state.newAddress = newAddress
    },
    setNewLocation(state,newLocation){
      state.newLocation = newLocation
    }
  },
  getters:{
  
  },
  actions: {
  },
  modules: {
  }
})
